import React, { Component } from "react";
import { Button } from "../../common/Button/Button";
import moment from 'moment';
import api from "../../utils/api";

class ESPSMSTrail extends Component {
  constructor(props) {
    super(props);
    this.state = {
      listOpen: false,
      headerTitle: this.props.title,
      auditLog:[]
    };
  }

  componentDidUpdate() {
    const { listOpen } = this.state;
    setTimeout(() => {
      if (listOpen) {
        window.addEventListener("click", this.close);
      } else {
        window.removeEventListener("click", this.close);
      }
    }, 0);
  }

  componentWillUnmount() {
    window.removeEventListener("click", this.close);
  }

  close = (e) => {
    if(this.SMSlogDropdown&&this.SMSlogDropdown.contains(e.target)){
      return
    }
    this.setState({
      listOpen: false
    });
  }

  toggleList() 
  {
    const { listOpen } = this.state;
    if(!listOpen)
    {
      let payload={nResourceInstanceId:this.props.nResourceInstanceId};
      api.getESPSMSLogByServiceId(payload).then(({ data }) => {
        this.setState({auditLog: data});
      });
    }

    this.setState(prevState => ({
      listOpen: !prevState.listOpen
    }));
  }

  renderAuditTrail = () => {
    const {auditLog = []} = this.state;

    return Object.keys(auditLog).map((key, i) => {
      return(
        <div className="mt-2" key={i}>
          <div className="flex justify-content-between">
            <small>{auditLog[key].external_sp}</small>
            <small>{moment(auditLog[key].date_created).format('lll')}</small>
          </div>
          <div className="audits-body mt-2">
            <div><small>SMS</small></div>
            <div style={{whiteSpace: "pre-line"}}>
              {auditLog[key].sms_content}
            </div>     
          </div>
        </div>
      )
    })
  }
  
  render() {
    const { listOpen } = this.state;
    const {auditLog = []} = this.state;
    return (
      <div style={{float:"left"}}>
        {/* <div className="dd-header" >
          <div className="dd-header-title">
            <Button style={{float:"left",marginRight:"10px"}}
            onClick={() => this.toggleList()}>SMS Trail</Button>
          </div>
        </div> */}

        <a className="con-cursor-pointer" target="_blank"
             style={{marginRight:"10px",marginLeft:"10px"}}
							onClick={() => this.toggleList()}
							>
						<span className="label-link"> SMS Trail</span>     
						</a>


        {listOpen && (
          <div ref={elem => this.SMSlogDropdown = elem}>
            <div className={`dd-list ${this.props.isFromLPM?' audit':this.props.isFromSPM? ' notes':' esp-audit'}`}>
                <div>
                    {Object.keys(auditLog).length > 0?this.renderAuditTrail():<div className="audits-body">No SMS Sent</div>}
                </div>
             </div>
          </div>
        )}
      </div>
    );
  }
}

export default ESPSMSTrail;
